import React from 'react'
import PropTypes from 'prop-types'

export const ModuleItem = ({ type, module, global }) => {
  switch (type) {
    case 'Cards':
      const { Cards } = require('@layouts')
      return <Cards {...module} />
    case 'Combo':
      const { Combo } = require('@layouts')
      return <Combo {...module.combo} />
    case 'CtaBillboardWithForm':
      const { CtaBillboardWithForm } = require('@layouts')
      return <CtaBillboardWithForm {...module} />
    case 'Events':
      const { Events } = require('@layouts')
      return <Events {...module} />
    case 'FullWidthBackgroundImage':
      const { FullWidthBackgroundImage } = require('@layouts')
      return <FullWidthBackgroundImage {...module} />
    case 'Hero1':
      const { HeroOne } = require('@layouts')
      return <HeroOne {...module.heroOne} />
    case 'Hero2':
      const { HeroTwo } = require('@layouts')
      return <HeroTwo {...module.heroTwo} />
    case 'Hero3':
      const { HeroThree } = require('@layouts')
      return <HeroThree {...module.heroThree} />
    case 'HeroText':
      const { HeroText } = require('@layouts')
      return <HeroText {...module} />
    case 'MediaKit':
      const { MediaKit } = require('@layouts')
      return <MediaKit {...module} />
    case 'MultipleContentSection':
      const { MultipleContentSection } = require('@layouts')
      return <MultipleContentSection {...module} />
    case 'RoleCards':
      const { RoleCards } = require('@layouts')
      return <RoleCards {...module} />
    case 'Wysiwyg':
      const { WYSIWYG } = require('@layouts')
      return <WYSIWYG {...module} />
    case 'PollingLocations':
      const { PollingLocations } = require('@layouts')
      return <PollingLocations {...module} />
    default:
      const { ModulePlaceholder } = require('@layouts')
      return <ModulePlaceholder type={type} />
  }
}

ModuleItem.propTypes = {
  type: PropTypes.string,
  module: PropTypes.object,
}
